import { API } from "aws-amplify";


const index = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: {
            account_id: params.account_id,
            notification_type: params.notification_type
        }, // OPTIONAL
        headers: {}
    };
    const res = await API.get("InasakuAPI", "/api/notifications", myInit);
    return res;
};

const insert = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };

    let res = await API.post("InasakuAPI", "/api/notifications", myInit);

    return res;
};

const update = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params, // replace this with attributes you need
        },
        headers: {} // OPTIONAL
    };

    let res = await API.put("InasakuAPI", `/api/notifications/${params.account_id}`, myInit);

    return res;
};


export default {
    index,
    insert,
    update
};
